export default "__VITE_ASSET__BrHE5mLu__"